import React from 'react';
import styles from './TabsContent.module.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

export const ClasicPlusDescription = () => {

  return (
    <div className={styles.container}>
      <p className={styles.mainTitle}>Cazane pe combustibili solizi  <span className={styles.highlight}>Classic Plus</span></p>
      <p className={styles.text}>
        Cazanele pe combustibili solizi <span className={styles.highlight}> Classic, Classic Plus</span> Folosite pentru încălzirea încăperilor casnice, industriale și a altor hale sau spații care necesita sa fie încălzite prin sistemul de încălzire centrala. Pentru a pregăti furnizarea căldurii pentru necesitățile tehnologice utilizând combustibili solizi că: lemne, deșeuri de lemn, cărbune, rumeguș și diverse brichete și torf. Construcția cazanului permite cea mai eficienta utilizare a căldurii din arderea diferitelor tipuri de combustibili solizi cu un conținut scăzut de calorii și cea mai mare putere termica a cazanului este obținută prin arderea antracitului. Durata de ardere a unei încărcări totale depinde în mod direct de combustibili și calitatea lor și pierderea de căldură a încăperii încălzite. Alimentarea cazanului se face numai prin modul manual cu combustibili solizi.
      </p>
      <h1 className={styles.title}>Arderea combustibilului în cuptor</h1>
      <p className={styles.text}>
        Arderea combustibilului în cuptor se realizează datorită tirajului de aer astfel :
      </p>
      <ul>
        <li>
          În cazanul <span className={styles.highlight}>Classic Plus</span> – pe canalul de alimentare cu aer cu ajutorul unui ventilator de sub grătarul de fontă. Aerul este necesar pentru procesul de combustie, ce se reglează automat de controller;
        </li>
        <li>
          În cazanul <span className={styles.highlight}>Classic</span> – fereastra supapei de alimentare cu aer, care se astupă cu un capac de sub grătarul de fontă. Cantitatea de aer necesară pentru procesul de combustie se reglează cu ajutorul unui regulator mecanic al tirajului de aer, prin tensionarea sau slăbirea lanțului controlează poziția capacului supapei.
        </li>
      </ul>
      <p className={styles.text}>
        Cazanele cu combustibili solizi Classic de la 20 kW
      </p>
      <div className={styles.guaranteeBox}>
        <div className={styles.guaranteeContent}>
          <i className="fa-solid fa-circle-plus fa-2x" />
          <p>
            Cazanele cu combustibili solizi <span className={styles.highlight}>Classic</span> de la 20 kW. Nu sunt echipate cu control mecanic de tiraj!
          </p>
        </div>
      </div>
      <p className={styles.text}>
        Cazanele <span className={styles.highlight}>Classic Plus/Classic</span> sunt echipate cu o supapa de siguranță, montate pe partea superioară a panoului. La presiune ridicata, supapa se deschide automat,astfel presiunea din cazan este normalizată.
      </p>
      <p className={styles.text}>
        Hornul cazanului este de forma rotunda. Acesta are un șubler, astfel se poate regla tirajul și economisi combustibilul.
      </p>
      <p className={styles.text}>
        Cazanele  <span className={styles.highlight}>Classic, Classic Plus</span> au următorii indicatori de putere : 20, 24, 30, 40, 50 și 60 kW, suficient pentru a încălzi o suprafață de 300 m² a unui imobil sau spațiu închis.
      </p>
      <h1 className={styles.title}>Caracteristicile  cazanului</h1>
      <p className={styles.text}>
        Carcasa și schimbătorul de căldură sunt făcute din oțel de calitate cu grosimea de 5 mm.Este rezistent la temperaturi foarte ridicate și este proiectat pentru o funcționare pe termen lung. Pentru a evita pierderea de căldură ,este învelit cu un strat de material izolant de 50 mm grosime, amplasat sub carcasa decorativa. Toate ușile cazanului sunt izolate termic, ceea ce previne pierderea de căldură și accidentele de arsuri umane.
      </p>
      <p className={styles.text}>
        În partea superioară a cazanului se afla un schimbător de căldura cu trei cai. Are o forma de rafturi orizontale în care apa circula constant. Astfel ca schimbătoarele de căldură orizontale se încălzesc rapid, asigurând cel mai eficient transfer de căldură. Grătarul din țevi este realizat fără sudura cu pereți groși prin care apa circula constant din din stratul cu apă al carcasei cazanului,ceea ce le sporește perioada de funcționare și reprezinta o zona suplimentara de eliminare a căldurii cazanului. Cazane pe combustibil solid Classic Plus, în versiunea lor de baza sunt recomandate sa fie înzestrate cu un sistem de comanda și o turbina cu injecție. Pentru a crește confortul utilizării acestui cazan ,este posibila instalarea unui regulator mecanic de temperatura. Astfel cazanul Clasic cu combustibili solizi nu este înzestrat cu unitate de automatizare și turbina cu injecție. Acest model poate funcționa numai cu controlul mecanic al tirajului de aer.
      </p>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Parametri</th>
              <th>U.M.</th>
              <th colSpan="5">Classic Plus</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Puterea nominală a cazanului</td>
              <td>kW</td>
              <td>24</td>
              <td>30</td>
              <td>40</td>
              <td>50</td>
              <td>60</td>
            </tr>
            <tr>
              <td>Suprafața schimbătorului de căldură</td>
              <td>m²</td>
              <td>1.4</td>
              <td>1.8</td>
              <td>2.0</td>
              <td>2.4</td>
              <td>2.9</td>
            </tr>
            <tr>
              <td>Eficiența, minim</td>
              <td>%</td>
              <td colSpan="5">91</td>
            </tr>
            <tr>
              <td>Volumul camerei de ardere</td>
              <td>dm³</td>
              <td>47</td>
              <td>68</td>
              <td>77</td>
              <td>96</td>
              <td>115</td>
            </tr>
            <tr>
              <td>Volumul apei din cazan</td>
              <td>l</td>
              <td>63</td>
              <td>71</td>
              <td>79</td>
              <td>90</td>
              <td>108</td>
            </tr>
            <tr>
              <td>Greutatea cazanului fără apă</td>
              <td>kg</td>
              <td>255</td>
              <td>315</td>
              <td>335</td>
              <td>370</td>
              <td>400</td>
            </tr>
            <tr>
              <td>Temperatura gazelor arse</td>
              <td>°C</td>
              <td colSpan="5">100-180</td>
            </tr>
            <tr>
              <td>Temperatura apei minim recomandată</td>
              <td>°C</td>
              <td colSpan="5">58</td>
            </tr>
            <tr>
              <td>Temperatura maximă a apei</td>
              <td>°C</td>
              <td colSpan="5">85</td>
            </tr>
            <tr>
              <td>Presiunea nominală a apei (maxim)</td>
              <td>MPa</td>
              <td colSpan="5">0.15</td>
            </tr>
            <tr>
              <td>Consumul de energie electrică, min</td>
              <td>W</td>
              <td colSpan="5">85</td>
            </tr>
            <tr>
              <td>Diametrul extern racord coș</td>
              <td>mm</td>
              <td>159</td>
              <td>195</td>
              <td>159</td>
              <td>159</td>
              <td>178</td>
            </tr>
            <tr>
              <td>Diametru conexiune rețelei de apă</td>
              <td>mm</td>
              <td colSpan="5">50</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th>Dimensiuni burlan</th>
              <th>U.M.</th>
              <th>201</th>
              <th>201</th>
              <th>201</th>
              <th>248</th>
              <th>248</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Secțiunea transversală</td>
              <td>cm²</td>
              <td>201</td>
              <td>201</td>
              <td>201</td>
              <td>248</td>
              <td>248</td>
            </tr>
            <tr>
              <td>Diametru intern</td>
              <td>mm</td>
              <td>160</td>
              <td>160</td>
              <td>160</td>
              <td>180</td>
              <td>180</td>
            </tr>
            <tr>
              <td>Înălțime (minim permisă)</td>
              <td>mm</td>
              <td>5</td>
              <td>5</td>
              <td>5</td>
              <td>5</td>
              <td>6</td>
            </tr>
            <tr>
              <td>Diametrul țevii de sub siguranțele supapei</td>
              <td>m³/ora</td>
              <td colSpan="5">15</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export const ClasicPlusDimensions = () => {
  const data = [
    { param: "B", unit: "mm", values: [590, 590, 590, 670, 670] },
    { param: "B1", unit: "mm", values: [470, 470, 470, 570, 570] },
    { param: "H", unit: "mm", values: [1290, 1450, 1450, 1450, 1550] },
    { param: "H1", unit: "mm", values: [1070, 1230, 1230, 1230, 1330] },
    { param: "L", unit: "mm", values: [860, 860, 910, 910, 960] },
    { param: "L1", unit: "mm", values: [695, 695, 745, 745, 795] },
    { param: "D", unit: "mm", values: [159, 159, 159, 178, 178] },
  ]

  const dataMecanic = [
    { param: "B", unit: "mm", values: [650, 650, 650, 730, 730] },
    { param: "H", unit: "mm", values: [1185, 1345, 1345, 1345, 1445] },
  ]

  const headers = ["Dimensiuni automatizat", "U.M.", "24 kW", "30 kW", "40 kW", "50 kW", "60 kW"];

  const headersMecanic = ["Dimensiuni mecanizat", "U.M.", "24 kW", "30 kW", "40 kW", "50 kW", "60 kW"];

  return (
    <div className={styles.dimensionsContainer}>
      <div className={styles.imageContainer}>
        <img src="/Dimensions/ClassicPlusSchemaAuto.png" alt="Descriptive Alt Text" className={styles.centeredImage} />
      </div>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{row.param}</td>
                <td>{row.unit}</td>
                {row.values.map((value, valueIndex) => (
                  <td key={valueIndex}>{value}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className={styles.imageContainer}>
        <img src="/Dimensions/ClassicPlusSchemaMecanic.png" alt="Descriptive Alt Text" className={styles.centeredImage} />
      </div>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              {headersMecanic.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {dataMecanic.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{row.param}</td>
                <td>{row.unit}</td>
                {row.values.map((value, valueIndex) => (
                  <td key={valueIndex}>{value}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};


